import {
  AuthService,
  EVENT_PLATFORMS,
  EVENTS_ORG,
  LoginMethods,
} from '@pw-tech/web-sdk';

const webSDK = AuthService.getInstance({
  clientSecret: "KjPXuAVfC5xbmgreETNMaL7z",
  organizationId: process.env.REACT_APP_PP_ORG_ID as string,
  apiBaseUrl: process.env.REACT_APP_PP_API_BASE_URL as string,
  loginMethods: [LoginMethods.OTP, LoginMethods.PASSWORD],
  localStorageFallback: true,
  clientId: 'system-admin',
  contextIdentifier: 'TOKEN_CONTEXT_AMBASSADOR',
  loginPageUrl: '/',
  debugMode: true,
  eventConfig: {
    organizationName: EVENTS_ORG.PHYSICS_WALLAH,
    eventPlatforms: [EVENT_PLATFORMS.GA],
    eventsDebugMode: false,
  },
});
export default webSDK;
